import React from 'react';

export const REVISION = 'd1e91cf4-a61b-44ae-9ffe-f17ac4cb900c';

export const ITEMS = [
    {
        selector: 'auth-widget',
        title: 'We have updated the license widget!',
        description: [
            <>
                <strong>License usage statistics</strong> and <strong>Log out</strong> are now also located here
            </>,
            'We will notify you when the expiration date or credits are nearing their end'
        ]
    },
    {
        selector: 'setting-menu-item',
        title: null,
        description: (
            <>
                <strong>Profile, License, API keys</strong>, and <strong>Security</strong> have moved to the Settings
                section
            </>
        )
    }
];
